import styled from '@emotion/styled'
import * as v from 'variables/styled'

export const MappingDataContainer = styled.div({
  display: 'flex',
  flex: 1,
  width: '100%',
  flexDirection: 'column',
  paddingTop: '20px',

  '.actionsContent': {
    'button.clear': {
      background: 'transparent',
    },

    'button.clear:hover': {
      background: '#DDD',
    }
  },
})